import React from 'react';
import { ArrowDownRightIcon, ArrowUpRightIcon, MinusIcon } from 'lucide-react';
import { fmtPP, fmtSignedPct } from '../../utils/format';
interface DeltaBadgeProps {
  value: number | null;
  kind: 'pct' | 'pp';
  label?: string;
}
export function DeltaBadge({
  value,
  kind,
  label
}: DeltaBadgeProps) {
  if (value === null || !isFinite(value)) {
    return <span className="text-xs text-ink-subtle" data-id="element-676" data-mp="27u0h4q176450">{label ? `${label} n/a` : 'n/a'}</span>;
  }
  const up = value > 0.0005;
  const down = value < -0.0005;
  const color = up ? 'text-positive' : down ? 'text-negative' : 'text-ink-muted';
  const Icon = up ? ArrowUpRightIcon : down ? ArrowDownRightIcon : MinusIcon;
  return <span className={`inline-flex min-w-0 max-w-full flex-wrap items-baseline gap-x-1 text-xs font-medium tabular-nums ${color}`} data-id="element-677" data-mp="2rfvhr179rg1p">
      <span className="inline-flex items-center gap-0.5 whitespace-nowrap" data-id="element-678" data-mp="35gpq5jubhh0d">
        <Icon className="h-3 w-3 self-center" aria-hidden data-id="element-679" data-mp="30h3c586nzwqi" />
        {kind === 'pp' ? fmtPP(value) : fmtSignedPct(value)}
      </span>
      {label && <span className="min-w-0 break-words font-normal text-ink-subtle" data-id="element-680" data-mp="287isf3s625ia">{label}</span>}
    </span>;
}